import useSWR from "swr";
import { getResourceActivity, getUserActivity } from "@/services/activity";
import { API_ROUTES } from "@/utils/constants";

export function useAuditLog(resourceId?: string, limit: number = 10) {
  const key = resourceId
    ? `${API_ROUTES.activity}?resourceId=${resourceId}&limit=${limit}`
    : `${API_ROUTES.activity}?limit=${limit}`;

  const { data, error, isLoading, mutate } = useSWR(
    key,
    async () => {
      if (resourceId) {
        return getResourceActivity(resourceId, limit);
      }
      return getUserActivity({ limit });
    },
    {
      revalidateOnFocus: false,
    }
  );

  return {
    activities: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}

export function useRecentActivity(limit: number = 20) {
  return useAuditLog(undefined, limit);
}

export function useFileActivity(fileId: string, limit: number = 10) {
  return useAuditLog(fileId, limit);
}
